var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{attrs:{"id":"compartilhamento"}},[_c('button',{on:{"click":_vm.share}},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icons.faShareNodes}}),_c('strong',[_vm._v("Compartilhar")])],1),_c('Share')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }